import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import SubmitLoading from "../../../utils/HelperComponent/SubmitLoading";
import PaginationComponent from "../pagination/PaginationComponent";

export default function ListsLayout({
  paginationHandler,
  title,
  subTitle,
  tableHeader,
  page,
  count,
  tableBody,
  children,
  loading,
}) {
  const [numTh, setNumTh] = useState(0);

  useEffect(() => {
    const thElements = document.querySelectorAll("th");
    setNumTh(thElements.length);
  }, []);
  const notFoundOrLoading = (
    <td className="text-center" colSpan={numTh}>
      {loading ? <SubmitLoading /> : "No data available yet."}
    </td>
  );

  return (
    <Card>
      <CardBody className="products-list">
        <Row>
          <Col md={12}>
            <h3
              className="fw-900 fs-14 text-uppercase c-text-dark-2"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            {!!subTitle && <h3 className="page-subhead subhead">{subTitle}</h3>}
          </Col>
        </Row>
        {children}
        <div className="table react-table ">
          <Table responsive bordered hover striped className="table-border">
            <thead>{tableHeader}</thead>
            <tbody>{tableBody?.length ? tableBody : notFoundOrLoading}</tbody>
          </Table>
        </div>

        {count && (
          <div className="my-4">
            <PaginationComponent
              count={count}
              page={page}
              paginationHandler={paginationHandler}
            />
          </div>
        )}
      </CardBody>
    </Card>
  );
}
